<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { useDataTransfer } from 'dashboard/composables/useDataTransfer';

/* eslint-disable vue/custom-event-name-casing */
const emit = defineEmits([
  'add',
  'import',
  'export',
  'select',
  'manage-labels',
  'manage-fields',
]);
/* eslint-enable vue/custom-event-name-casing */

const { t } = useI18n();
const { checkPermissions } = usePolicy();
const { isUnified } = useDataTransfer();

const transferMenuItems = legacyItems => {
  if (!checkPermissions(['administrator', 'contact_manage'])) return [];
  if (!isUnified.value) return legacyItems;
  return [
    {
      label: t('DATA_TRANSFER.MENU_IMPORT'),
      action: 'import',
      value: 'import',
      icon: 'i-lucide-download',
    },
    {
      label: t('DATA_TRANSFER.MENU_EXPORT'),
      action: 'export',
      value: 'export',
      icon: 'i-lucide-upload',
    },
  ];
};

const contactMenuItems = computed(() => [
  {
    label: t('CONTACTS_BULK_ACTIONS.SELECT_CONTACTS'),
    action: 'select',
    value: 'select',
    icon: 'i-lucide-check-square',
  },
  {
    label: t('BULK_ACTION.LABELS.MANAGE_LABELS'),
    action: 'manage-labels',
    value: 'manage-labels',
    icon: 'i-lucide-tag',
  },
  {
    label: t('ATTRIBUTES_MGMT.MANAGE_FIELDS'),
    action: 'manage-fields',
    value: 'manage-fields',
    icon: 'i-lucide-settings-2',
  },
  ...transferMenuItems([
    {
      label: t(
        'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.EXPORT_CONTACT'
      ),
      action: 'export',
      value: 'export',
      icon: 'i-lucide-upload',
    },
    {
      label: t(
        'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.IMPORT_CONTACT'
      ),
      action: 'import',
      value: 'import',
      icon: 'i-lucide-download',
    },
  ]),
]);
const showActionsDropdown = ref(false);

const handleContactAction = ({ action }) => {
  if (action === 'add') {
    emit('add');
  } else if (action === 'import') {
    emit('import');
  } else if (action === 'export') {
    emit('export');
  } else if (action === 'select') {
    emit('select');
  } else if (action === 'manage-labels') {
    // eslint-disable-next-line vue/custom-event-name-casing
    emit('manage-labels');
  } else if (action === 'manage-fields') {
    // eslint-disable-next-line vue/custom-event-name-casing
    emit('manage-fields');
  }
};
</script>

<template>
  <div
    v-if="contactMenuItems.length > 0"
    v-on-clickaway="() => (showActionsDropdown = false)"
    class="relative"
  >
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="contactMenuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      @action="handleContactAction($event)"
    />
  </div>
</template>
